
import 'components/catalog.tag'
import 'pages/products/options/optionitem-edit-modal.tag'
riot.tag2('options-items-list', '  <catalog name="optionItem" object="OptionItems" cols="{cols}" search="true" allselect="true" reorder="true" handlers="{handlers}" reload="true" store="parameters-list" filters="{opts.filters}" add="{permission(addItem, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(editItem, &quot;products&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="image"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}"></datatable-cell>\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="price"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.price.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="nameOption">{row.nameOption}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;
self.mixin('permissions');
self.mixin('remove');
self.collection = 'OptionItems';

self.addItem = function () {
    var idOption = 0;
    if (opts.filters !== undefined) {
        idOption = opts.filters[0].value;
    }
    modals.create('optionitem-edit-modal', {
        type: 'modal-primary',
        option: idOption,
        submit: function submit() {
            var _this = this;
            var params = _this.item;
            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'OptionItems',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        self.tags['optionItem'].reload();
                        _this.modalHide();
                    }
                });
            }
        }
    });
};

self.editItem = function (e) {
    var item = void 0;

    if (e.item && e.item.row) item = e.item.row;
    modals.create('optionitem-edit-modal', {
        type: 'modal-primary',
        item: item,
        submit: function submit() {
            var _this = this;
            var params = _this.item;
            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'OptionItems',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        self.tags['optionItem'].reload();
                        _this.modalHide();
                    }
                });
            }
        }
    });
};

self.cols = [{ name: 'image', value: 'Фото' }, { name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'measure', value: 'Цена' }, { name: 'nameOption', value: 'Опция' }];

self.one('updated', function () {
    self.tags['optionItem'].tags.datatable.on('reorder-end', function () {
        var _self$tags$optionItem = self.tags['optionItem'].pages,
            current = _self$tags$optionItem.current,
            limit = _self$tags$optionItem.limit;

        var params = { indexes: [] };
        var offset = current > 0 ? (current - 1) * limit : 0;

        self.tags['optionItem'].items.forEach(function (item, sort) {
            item.sort = sort + offset;
            params.indexes.push({ id: item.id, sort: sort + offset });
        });

        API.request({
            object: 'OptionItems',
            method: 'Sort',
            data: params,
            notFoundRedirect: false
        });

        self.update();
    });
});
});


// WEBPACK FOOTER //
// ./pages/products/options/options-items-list.tag